module.exports = __webpack_public_path__ + "img/banner-login.62d67740.png";